<template>
  <a-card hoverable :title="item.title" style="width: 330px; cursor: default; margin: 0 auto;">
    <template #extra>
      <a-button id="btn-dl" type="primary" shape="round" v-if="item.content" @click="$emit('showModal', item.content)">
        <template #icon>
          <FullscreenOutlined />
        </template>
        {{ item.text }}
      </a-button>
      <a-button id="btn-dl" type="primary" shape="round" @click="$emit('launchTeams')" v-else>
        <template #icon>
          <ExportOutlined />
        </template>
        {{ item.text }}
      </a-button>
    </template>

    <div style="margin-bottom: 10px; text-align: center;" v-if="item.icon">
      <a @click="$emit('showModal', item.content)" v-if="item.content">
        <img alt="icon" :src="item.icon" style="height: 128px; cursor: pointer"/>
      </a>
      <a @click="$emit('launchTeams')" v-else>
        <img alt="icon" :src="item.icon" style="height: 128px; cursor: pointer"/>
      </a>
    </div>
    <a-card-meta :title="item.filename">
      <template #description>{{ item.desc }}</template>
    </a-card-meta>
  </a-card>
</template>

<script>
import { ExportOutlined, FullscreenOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    ExportOutlined,
    FullscreenOutlined
  },
  props: ["item"]
}
</script>
